import React from 'react';
import { Shield, Home } from 'lucide-react';
import { useUserRole } from '../hooks/useUserRoleSecure';
import './AdminLayout.css';

/**
 * AdminLayout component
 * Provides the layout structure for admin user management
 */
const AdminLayout = ({ children }) => {
  const { userRole } = useUserRole();

  return (
    <div className="admin-layout-simple">
      {/* Admin header bar */}
      <header className="admin-header">
        <div className="admin-header-content">
          <div className="admin-title-section">
            <Shield size={24} />
            <h1 className="admin-page-title">User Management</h1>
          </div>
          <div className="admin-role-badge">
            {userRole}
          </div>
        </div>

        <div className="admin-header-actions">
          <button
            className="back-to-app-btn"
            onClick={() => window.location.href = '/'}
            title="Back to Main App"
          >
            <Home size={20} />
            <span>Back to Main App</span>
          </button>
        </div>
      </header>

      {/* Page content */}
      <main className="admin-content">
        {children}
      </main>
    </div>
  );
};

export default AdminLayout;